import { UserSearchCard } from '@platform/client/schemas';
import { Avatar, CountryIcon, Icon, ISO3166Alpha2Code, PillBadge } from '@platform/components';

type UserCardProps = {
  user: UserSearchCard;
};

export const UserCard = (props: UserCardProps) => {
  const {
    firstName,
    lastName,
    skills,
    yearsExperience,
    image,
    id,
    headline,
    positionTitle,
    employer,
    country,
    countryCode,
  } = props.user;

  return (
    <div className='min-w-[280px] h-full flex flex-col bg-white border border-gray-100 rounded-xl p-4'>
      <div className='flex flex-row gap-3'>
        {image ?
          <Avatar type={'avatar'} size='xl' avatarUrl={image} additionalClassNames='shrink-0' />
        : <Avatar
            type={'initials'}
            size='xl'
            name={`${firstName} ${lastName}`}
            additionalClassNames='shrink-0'
          />
        }
        <div className='flex flex-col flex-shrink'>
          <div className='text-base font-semibold text-gray-700'>
            {firstName} {lastName}
          </div>
          {(positionTitle || headline) && (
            <div className='text-sm text-gray-700 line-clamp-2 mt-1'>
              {positionTitle ?? headline ?? `${yearsExperience} years of experience`}
            </div>
          )}
          {employer && <div className='text-sm text-gray-400 mt-1'>{employer}</div>}
          {country && (
            <div className='text-sm text-gray-400 flex flex-row items-center gap-1 mt-1'>
              {countryCode && <CountryIcon alpha2={countryCode as ISO3166Alpha2Code} height={16} />}
              {country}
            </div>
          )}
        </div>
      </div>
      <div className='flex flex-col gap-3 flex-1'>
        {skills.length > 0 && (
          <div className='flex flex-row gap-1 flex-wrap mt-3'>
            {skills.map((skill) => (
              <PillBadge key={skill} size='sm' variant='plain' color='gray'>
                {skill}
              </PillBadge>
            ))}
          </div>
        )}
        <a
          className='w-full flex items-center justify-center gap-x-1 mt-auto h-10 px-3.5 py-2.5 border border-gray-200 rounded-lg shadow-xs text-sm font-semibold text-gray-500 bg-white cursor-pointer'
          href={`/platform/directory/professionals/${id}`}
        >
          See profile
          <Icon type='chevron-right' size='20' />
        </a>
      </div>
    </div>
  );
};
